import AppSettings from 'es/core/AppSettings';

class AuthParameters {
    public static createRequestHeaders(companyAlias?: string, facilityAlias?: string) {
        const headers = {} as any;

        if (AppSettings.isDevelopment && AppSettings.apiKey) headers['Authorization'] = `Token ${AppSettings.apiKey}`
        if (companyAlias) headers[AppSettings.requestHeaders.companyAlias] = companyAlias;
        if (facilityAlias) headers[AppSettings.requestHeaders.facilityAlias] = facilityAlias;

        return headers;
    }
}

export default AuthParameters;
